/**
 * CbbCta — band-matched Coach Business Builder closing CTA for CIH V3 pages.
 * Resolves the destination + copy from the page's CTA stage band and renders
 * the shared dark closing band.
 *
 * Aliases: cbb cta band, coach business builder cta, stage cta
 */
import { CihClosingCta } from "~/components/cih/closing-cta";
import { Button } from "~/components/ui/button";
import { getCbbCta } from "~/lib/shared/cih/cbb-cta";
import type { PracticeStageBand } from "~/lib/shared/content-status";

type Props = {
  readonly band: PracticeStageBand | null;
  readonly kicker?: string;
};

export function CbbCta({ band, kicker }: Props) {
  const cta = getCbbCta(band);
  return (
    <CihClosingCta
      kicker={kicker}
      headline={cta.copy}
      cta={
        <a href={cta.href}>
          <Button variant="primary" size="lg">
            {cta.label} →
          </Button>
        </a>
      }
    />
  );
}
